<template>
  <input-select
    id="ethnicity"
    :value="value"
    name="ethnicity"
    label="Ethnicity"
    placeholder="Any"
    placeholder-enabled
    :options="[
      { id: 'native', display_label: 'American Indian or Alaskan Native' },
      { id: 'asian', display_label: 'Asian' },
      { id: 'black', display_label: 'Black or African American' },
      { id: 'hispanic', display_label: 'Hispanic' },
      { id: 'multiracial', display_label: 'Multiracial' },
      { id: 'other', display_label: 'Other' },
      { id: 'pacific', display_label: 'Pacific' },
      { id: 'white', display_label: 'White' },
    ]"
    @input="val => $emit('input', val)"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
    name: 'EthnicityPicker',

    components: {
        InputSelect
    },

    props: {
    value: {
      type: String,
      required: true
    }
  },
};
</script>
